import { TextField as TPATextField, BoxSelectionBoxSize, BoxSelectionSelectionType, TextFieldTheme } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useMemo, useCallback, useState } from 'react';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useTranslation } from '../../contexts/translation-context';
import BoxSelectionItem from '../../ui/box-selection-item';
import Fieldset from '../../ui/fieldset';
import { OptionsLayout } from '../../ui/options-layout';
import { NUMBER_OF_COLUMNS } from '../../ui/options-layout/options-layout-constants';
import { getOtherValue, OTHER_ID } from '../../ui/tags-field/tags-field-utils';
import { classes } from '../../ui/tags-field/tags-field-wut.st.css';
const TagsInputWUT = _ref => {
  let {
    addOtherPlaceholder,
    otherInputCharacterLimit,
    disabled,
    onFocus,
    onBlur,
    addOther,
    addOtherLabel,
    value,
    options,
    numberOfColumns,
    onChange,
    ariaDescribedBy,
    inputId,
    labelId,
    required,
    hasError,
    label,
    id
  } = _ref;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const isFreeFlow = numberOfColumns === NUMBER_OF_COLUMNS.FREE_FLOW;
  const _value = useMemo(() => value || [], [value]);
  const _options = useMemo(() => options.map(option => ({
    title: option.label,
    value: option.value ?? option.label
  })), [options]);
  const handleChange = useCallback(optionValue => {
    const newValue = _value.includes(optionValue) ? _value.filter(val => val !== optionValue) : [..._value, optionValue];
    onChange == null || onChange(newValue);
  }, [_value, onChange]);
  const optionsNames = useMemo(() => options.map(option => option.label), [options]);
  const isOtherOptionSelected = useMemo(() => {
    if (!addOther) {
      return false;
    }
    return _value.some(val => {
      return val === addOtherLabel || val.startsWith(`${addOtherLabel}:`);
    });
  }, [_value, addOther, addOtherLabel]);
  const [otherSelected, setOtherSelected] = useState(isOtherOptionSelected);
  const [otherValue, setOtherValue] = useState(isOtherOptionSelected ? getOtherValue(_value, addOtherLabel) : '');
  const {
    t
  } = useTranslation();
  const otherLabel = addOtherLabel || (t == null ? void 0 : t('add-other.default-other-option-label')) || OTHER_ID;
  const otherOptionChange = () => {
    const _otherSelected = !otherSelected;
    setOtherSelected(_otherSelected);
    setOtherValue('');
    handleOtherChange(_otherSelected ? `${otherLabel}` : '');
  };
  const handleOtherChange = useCallback(newValue => {
    const filteredValues = _value.filter(val => optionsNames.includes(val));
    const updatedValues = newValue ? [...filteredValues, newValue] : filteredValues;
    onChange(updatedValues);
  }, [onChange, optionsNames, _value]);
  const handleOtherInputChange = event => {
    const input = event.target.value;
    const _otherValue = input ? `${addOtherLabel}: ${input}` : otherLabel;
    setOtherValue(input);
    handleOtherChange(_otherValue);
  };
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    ariaLabelledBy: labelId,
    required: required,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaDescribedBy: ariaDescribedBy
  }, options.length > 0 && /*#__PURE__*/React.createElement(OptionsLayout, {
    numberOfColumns: numberOfColumns,
    tabIndex: -1
  }, _options.map((_ref2, index) => {
    let {
      title: optionTitle,
      value: optionValue
    } = _ref2;
    const isChecked = _value.includes(optionValue);
    return /*#__PURE__*/React.createElement(BoxSelectionItem, {
      id: optionValue,
      name: optionValue,
      size: BoxSelectionBoxSize.small,
      disabled: disabled,
      type: BoxSelectionSelectionType.CHECKBOX,
      key: `tags-${optionValue}`,
      "data-hook": `tags-${optionValue}`,
      checked: isChecked,
      onChange: event => {
        handleChange(event.id);
      },
      className: classNames({
        [classes.tag]: isFreeFlow
      }),
      forcedHover: forcedHover,
      content: optionTitle,
      hasError: hasError,
      inputId: index === 0 ? id : undefined
    });
  }), addOther && /*#__PURE__*/React.createElement(BoxSelectionItem, {
    id: `tags-${OTHER_ID}`,
    name: label,
    size: BoxSelectionBoxSize.small,
    disabled: disabled,
    type: BoxSelectionSelectionType.CHECKBOX,
    checked: otherSelected,
    onChange: otherOptionChange,
    content: addOtherLabel || 'Other',
    className: classNames({
      [classes.tag]: isFreeFlow
    }),
    forcedHover: forcedHover,
    hasError: hasError
  })), otherSelected && /*#__PURE__*/React.createElement(TPATextField, {
    className: classNames(classes.otherInput, classes.theme, {
      [classes.hover]: forcedHover,
      [classes.filled]: Boolean(otherValue)
    }),
    value: otherValue,
    placeholder: addOtherPlaceholder,
    maxLength: otherInputCharacterLimit,
    onChange: handleOtherInputChange,
    disabled: disabled,
    error: hasError,
    inputMode: "text",
    "data-hook": "tags-other-input",
    theme: TextFieldTheme.Box,
    "aria-label": otherLabel
  }));
};
export default TagsInputWUT;
//# sourceMappingURL=tags-input-wut.js.map